/**
 * Phone admin keeps the section list off the page until it is opened. At `md` and up the
 * sidebar stays in the row, the same sticky column it has always been.
 */
export function adminSidebarClass(open: boolean): string {
  const phone = open ? 'max-md:fixed max-md:top-16 max-md:bottom-0 max-md:left-0 max-md:z-40' : 'max-md:hidden';
  return `${phone} md:sticky md:top-16 md:z-auto md:block md:h-[calc(100vh-4rem)] w-56 shrink-0 overflow-y-auto border-r border-zinc-200 bg-white`;
}
